<script setup>
import { computed } from 'vue'

const props = defineProps({
  messages: { type: Array, required: true },
  // Iniciais do cliente no avatar. Antes era "CA" fixo, de "Carlos".
  clientName: { type: String, default: '' },
})

const clientInitials = computed(
  () =>
    props.clientName
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0].toUpperCase())
      .join('') || '—',
)
</script>

<template>
  <ol class="space-y-4" aria-live="polite">
    <li
      v-for="message in messages"
      :key="message.id"
      class="flex gap-3"
      :class="message.from === 'client' && 'flex-row-reverse'"
    >
      <span
        class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[10px] font-bold"
        :class="message.from === 'team' ? 'bg-up-navy text-white' : 'bg-up-orange text-white'"
        aria-hidden="true"
      >{{ message.from === 'team' ? 'UP' : clientInitials }}</span>

      <div class="max-w-[80%]">
        <p
          class="flex flex-wrap items-baseline gap-x-2"
          :class="message.from === 'client' && 'justify-end'"
        >
          <span class="text-sm font-semibold text-up-navy">{{ message.author }}</span>
          <time class="text-xs text-slate-500">{{ message.at }}</time>
        </p>
        <p
          class="mt-1 rounded-lg px-4 py-3 text-sm leading-relaxed"
          :class="message.from === 'team'
            ? 'bg-up-bg text-slate-600'
            : 'bg-up-orange/10 text-up-navy'"
        >{{ message.text }}</p>
      </div>
    </li>
  </ol>
</template>
